<span class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ statusMessage }}</span>
<div class="tw-pt-6">
    @if (loading) {
        <!-- Loading -->
        <div #spinnerRef tabindex="-1" class="tw-text-center">
            <p-progress-spinner  styleClass="p-progress-spinner-lg" strokeWidth="4" />
            <p class="tw-mt-4 tw-text-gray-600">{{'createExport.dialog.creatingExportText' | transloco}}</p>
        </div>
    } @else if (exportCreated) {
        <!-- Success -->
        <div>
            <p class="tw-mb-6">{{'createExport.dialog.exportCreatedText' | transloco}}</p>
            <p>{{'createExport.dialog.viewExportsText' | transloco}}</p>
            <div class="tw-flex tw-gap-3 tw-justify-end tw-mt-6">
                <div #successButtonRef tabindex="-1" class="tw-inline-block">
                    <p-button 
                        label="{{'createExport.dialog.myExportsButton' | transloco}}" 
                        (onClick)="openMyExports()"
                        data-test="create-export-my-exports-button"
                    />
                </div>
            </div>
        </div>
    } @else {
        <div>
            <div #exportButtonRef tabindex="-1" class="tw-inline-block tw-w-full">
                <p-button 
                    icon="pi pi-download"
                    [label]="config.buttonLabel"
                    [fluid]="true"
                    (onClick)="createExport()"
                    data-test="create-export-export-button"
                    variant="outlined"
                    class="tw-w-full"
                />
            </div>
        </div>
    }
</div>
